import PhaseEdit from './Phases'

export default {
    edit: PhaseEdit
};